// extracted by mini-css-extract-plugin
export var chevron = "_1f-d";
export var disabled = "_1f-b";
export var error = "_1f-c";
export var hideBorder = "_1f-1";
export var icon = "_1f-e";
export var input = "_1f-0";
export var large = "_1f-f";
export var open = "_1f-9";
export var placeholder = "_1f-a";
export var regular = "_1f-5";
export var singleRowInput = "_1f-2";
export var singleSelectInput = "_1f-3 _1f-0";
export var small = "_1f-4";
export var spinnerContainer = "_1f-i";
export var tag = "_1f-7";
export var tagsContainer = "_1f-8";
export var tagsInput = "_1f-6 _1f-0";
export var xSmall = "_1f-g";
export var xxSmall = "_1f-h";